export default {"src":"/_next/static/media/wireless_internet.aa37c921.svg","height":100,"width":100};